export default __webpack_public_path__ + "static/hotel-accuracy-ca624e5ae6714bf32c77ee802de34dca.png";